import { toast } from 'react-toastify'; // For displaying notifications
import { GetCafeteriaById, UpdateCafeteria } from "../../../../../reduxToolkit/FoodieCafeteria/CafeteriaApi"; // API calls
import { useLocation } from "react-router-dom"; // React Router hook for accessing route state
import { useEffect } from "react";
import { CAFETERIA_MODEL } from "../Model/Models"; // Default cafeteria model
import {
    DAYS_MODEL,
    DEFAULT_LATITUDE,
    DEFAULT_LONGITUDE,
    deviceListToLabel,
    errorMsg
} from "../../../../../Apis/functions"; // Helpers for days and coordinates

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Custom hook for updating cafeteria data
const UpdateCafeteriaApp = ({
                                t,                       // i18n translation function
                                item,                    // Current cafeteria model
                                setItem,                 // Setter for cafeteria model
                                setEmptyFields,          // Setter for indicating empty required fields
                                dispatch,                // Redux dispatch function
                                deviceSelectedList,      // List of selected devices for cafeteria
                                setDeviceSelectedList,   // Setter for selected devices
                                dayArray,                // Array of selected days
                                setDayArray,             // Setter for selected days
                                toRegisterDays,          // Function to convert days array to model
                                setShowOverlay,          // Setter for overlay visibility
                                setIsValid,              // Setter for capacity field validation
                                setFirstClickOnMap,       // Setter for map interaction state
                                isValidCloseTime,
                                setIsValidCloseTime
                            }) => {
    const location = useLocation(); // React Router hook for accessing current route
    const state = location.state;   // Access route state (e.g. ID passed from previous page)
    const id = state && state.state; // Cafeteria ID for editing

    /**
     * On component mount:
     * - Fetch cafeteria data by ID
     * - Populate form model with fetched data
     * - Set devices and days from fetched data
     * - Manage overlay and map click state based on coordinates
     */
    useEffect(() => {
        getCafeteriaById(id);
    }, []);

    const getCafeteriaById = (id) => {
        dispatch(GetCafeteriaById(id)).then(({ payload: { data: { data } } }) => {
            if (data?.id) {
                // Populate cafeteria model with fetched data
                setItem(CAFETERIA_MODEL.set(data));
                // Populate device selection list
                setDeviceSelectedList(deviceListToLabel(data?.devices));


                // Populate days array from saved schedule
                setDayArray(toShowSavedDays(data?.schedule));

                // Handle overlay and map click state
                if (data?.longitude === DEFAULT_LONGITUDE && data?.latitude === DEFAULT_LATITUDE) {
                    setShowOverlay(true);
                    setFirstClickOnMap(false);
                } else {
                    setShowOverlay(false);
                    setFirstClickOnMap(true);
                }

            }
        });
    }

    /**
     * Function to handle cafeteria update:
     * - Validates required fields
     * - Validates capacity
     * - Converts selected days
     * - Dispatches update API call
     * - Handles success/error notifications
     */

    const handleUpdate = () => {
        // Validate basic required fields and days
        if (!item.isValidSetUpData() || !item.isValidAccessData(dayArray) || !isValidCloseTime) {
            setEmptyFields(true);
            toast.warning(t("please_fill_all_fields"));
            return;
        }

        // Validate capacity
        if (!item.isValidCapacity()) {
            setIsValid(false);
            return;
        }

        setIsValid(true);
        setIsValidCloseTime(true);

        // Prepare data for update
        let aux = { ...item, deviceIds: deviceSelectedList.map(e => e.id) };
        aux = toRegisterDays(aux);

        // Convert to request body
        let body = aux.toRegister();

        // Dispatch update API call
        dispatch(UpdateCafeteria(body)).then(({ payload: { data: { data, code } } }) => {
            if (data?.id) {
                getCafeteriaById(data?.id);
                toast.success(t('has_been_updated_successfully')); // Show success message
            } else errorMsg(code)
        });
    };

    /**
     * Helper function:
     * Converts a cafeteria's saved schedule into an array of selected days.
     * Example: {monday: true, tuesday: false} → ['Lunes']
     */
    const toShowSavedDays = (schedule) => {
        let aux = [];
        Object.entries(schedule).map(([key, value]) => {
            if (value === true) {
                let day = DAYS_MODEL.find(obj => obj.key === key);
                aux.push(day.value);
            }
        });
        return aux;
    };

    // Return the update handler
    return { handleUpdate };
};

export default UpdateCafeteriaApp;
